import config from 'services/config'

const install = function (Vue, options) {
    Vue.mixin({
        computed: {
            $totemLang () { return config.appLanguage },
            $isLangFi () { return this.$totemLang === 'fi' },
            $isLangSe () { return this.$totemLang === 'se' },
            $isLangNo () { return this.$totemLang === 'no' }
        },
        methods: {
            getTimeZone () {
                switch (this.$totemLang) {
                case 'fi':
                    return 'Europe/Helsinki'
                case 'se':
                    return 'Europe/Stockholm'
                case 'no':
                    return 'Europe/Oslo'
                }
            }
        }
    })
}

export default { install }
